module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAxCAYAAABDEFA9AAABMklEQVRoQ+2ZQQ6CMBBFZwKHULd4Gb2GiRcw6hnEeASuoZeRpcIhwLogJiLQlsKYGj/rafvzMv2fTLm4bhbMYUKkpmT8OFOqWIXz08VYKlDAZbq/2wl9nc5ZEB1mAlqMW3KZ7pSx6qMgiGLuu2aMeogdg2LbHiALskSENugOmmGhIkJWHzTuoSIkVh80rqECsaYIB9kuczeRAVmpUPg7svVgqcLEW+tqBgtnHottBgvEjnHB2vYAWZD1ORTQs20/O+hZv3u2MTDMvfXZIt0umTghogkR3xQ91t6K/dqsa4wLBrFS1gWyINsxAxCyLu0LUB5EscUzVlOxiNi6ob8fWpl7GB3PLtNxEbEuQmzWQKwNJZcakHWhZrPm18j2fRUnZ5+0oaer4W5PbP2VGOSTQ8U+AVUFmvG1cyb/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/icon_1@2x.png
// module id = gnTt
// module chunks = 69